import { Phone } from "lucide-react";
import { BUSINESS } from "../data/site";
import { useRequestModal } from "./RequestModal";
import { track } from "../lib/api";
import Reveal from "./Reveal";

export default function CTASection({ title = "Ready for a Dumpster That Shows Up?", subtitle = "Request online in about a minute, or call and talk to a real person. Monday–Friday, 8:00 AM–5:00 PM.", dark = true }) {
  const { openRequest } = useRequestModal();
  return (
    <section className={`${dark ? "bg-ink" : "bg-sky-50 border-y border-sky-100"} py-16 sm:py-20`} data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <h2 className={`font-heading font-bold text-3xl sm:text-4xl tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>{title}</h2>
          <p className={`mt-4 text-base sm:text-lg ${dark ? "text-slate-400" : "text-slate-600"}`}>{subtitle}</p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => openRequest()}
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-sky-600 hover:bg-sky-500 text-white font-heading font-semibold transition-all active:scale-[0.98]"
              data-testid="cta-request-dumpster"
            >
              Request a Dumpster
            </button>
            <a
              href={BUSINESS.phoneHref}
              onClick={() => track("click_to_call", { location: "cta_section" })}
              className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg font-heading font-semibold transition-all active:scale-[0.98] ${dark ? "border-2 border-slate-600 text-white hover:border-sky-400" : "border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"}`}
              data-testid="cta-call"
            >
              <Phone className="h-4 w-4" /> Call for Same-Day Service
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
